// extracted by mini-css-extract-plugin
export default {"studentsWrapper":"UnavailableStudents_studentsWrapper__Bl-TW"};